import { useRouter } from "next/router";

import messages, { MessageType, TransMsg } from "../i18n/messages";

function getMessage(msg: TransMsg, locale?: string): string {
  if (!locale || !msg) return ""; // Ensure locale and msg are defined

  const normalizedLocale = locale.replaceAll("-", ""); // Normalize locale (remove hyphens)
  return msg[normalizedLocale] || ""; // Return the message if found, or an empty string
}

export interface Translation {
  msg: MessageType;
  t: (msg: TransMsg) => string;
}

export function useTranslation(): Translation {
  const { locale } = useRouter();

  const t = (msg: TransMsg) => {
    return getMessage(msg, locale);
  };

  return { msg: messages, t };
}
